import { lenis } from '../include/_lenis.js';
import scrollIn, { followBtns , splitText } from '../include/_scrollIn.js';
import { mainVisualSwiper, interviewSwiper, crossTalkSwiper, newsSwiper, mobileSwiper } from '../include/_swiper.js';
import { scrollBlur , scrollChangeColor, scrollParallax , careerFollowMenu , scrollTopPosition} from '../include/_gsap.js';
import { hoverChange } from '../include/_hover-change.js';
import { subMenu } from '../include/_submenu.js';
import { numbers } from '../include/_numbers.js';
import { youtubeAPI } from '../include/_youtube.js';
import { viewTransition } from '../include/_viewTransition.js';

const initScripts = () => {

  if (typeof lenis === 'function') 
    lenis();

  if (typeof scrollIn === 'function') 
    scrollIn();

  if (typeof followBtns === 'function')
    followBtns();

  if (typeof splitText === 'function')
    splitText(100);

  if (typeof mainVisualSwiper === 'function') 
    mainVisualSwiper();

  if (typeof interviewSwiper === 'function') 
    interviewSwiper();

  if (typeof newsSwiper === 'function') 
    newsSwiper();

  if (typeof crossTalkSwiper === 'function') 
    crossTalkSwiper();

  if (typeof mobileSwiper === 'function')
    mobileSwiper();

  if (typeof hoverChange === 'function') 
    hoverChange();

  if (typeof scrollBlur === 'function')  {
    scrollBlur({
      targetClass: '.main-visual-swiper',
      onUpdate: (target, blurValue, progress) => {
        const bgOpacity = 0.3 + (progress * (0.7 - 0.3));
        const imgOpacity = 0 + (progress * (1.0 - 0.03));
        target.querySelector('.layer').style.backgroundColor = `rgba(11, 25, 9, ${bgOpacity})`;
        target.querySelectorAll('.blur-image').forEach(image => {
          image.style.opacity = imgOpacity;
        });
      }
    });
  }

  if (typeof subMenu === 'function') 
    subMenu();

  if (typeof scrollParallax === 'function') 
    scrollParallax('.scroll-parallax');

  if (typeof careerFollowMenu === 'function')
    careerFollowMenu();

  if (typeof viewTransition === 'function')
    viewTransition();

  if (typeof numbers === 'function') 
    numbers();

  if (typeof scrollChangeColor === 'function') {
    // ヘッダーの背景色とテキストカラーの変更
    const headerHeight = document.querySelector('header').clientHeight;
    scrollChangeColor({
      selector: '[data-header-bg][data-header-text]',
      targetSelector: 'body',
      activeClass: {
        className: 'is-colored',
        target: 'header'
      },
      trigger: {
        start: `top top+=${headerHeight}px`,
        end: `bottom top`,
        markers: false
      },
      cssVars: {
        attributes: {
          'header-bg': '--header-bg',
          'header-text': '--header-text'
        },
        defaults: {
          '--header-bg': 'transparent',
          '--header-text': 'var(--r-white)'
        }
      }
    });

    // Instagramアイコンのカラー変更
    scrollChangeColor({
      selector: '[data-i-color][data-i-display]',
      targetSelector: 'body',
      activeClass: {
        className: 'is-colored',
        target: '.follow-instagram'
      },
      trigger: {
        start: 'top center-=10%',
        end: 'bottom center+=10%',
        markers: false
      },
      cssVars: {
        attributes: {
          'i-color': '--i-color',
          'i-display': '--i-display'
        },
        defaults: {
          '--i-color': 'var(--r-primary)',
          '--i-display': 'block'
        }
      }
    });
  }


  if (typeof scrollTopPosition === 'function') 
    scrollTopPosition({ 
      target: '.js-scroll-point', 
      el: '.js-scroll-point-target',
      threshold: document.querySelector('header').offsetTop, 
      className: 'is-scroll-end' 
    });
    

  if (typeof youtubeAPI === 'function')
    youtubeAPI();
  
}

document.addEventListener('DOMContentLoaded', initScripts, false);
